export enum GiftCardStepEnum {
  Reset = 0,
  Init = 5,
  SelectGiftCard = 10,
  Login = 20,
  Register = 30,
  RegisterAsGuest = 40,
  Payment = 50,
}
